import Entrance from "../../layouts/Entrance";
import styles from './style.module.scss';
import { useEffect, useState } from "react";
import Input from "../../components/Input";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import MotionWrapper from "../../layouts/MotionWrapper";
import { useDispatch, useSelector } from "../../store/store";
import { signInThunk } from "../../store/auth/thunks";
import { selectFetchStatus } from "../../store/auth/selectors";
import { validateEmail } from "../../utils/generalHelpers";
import { setSignUpStep } from "../../store/signUp/slice";
import { LockIcon, TypographyLogo } from "../../assets/icons";

function SignIn() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState('');
    const from = location.state?.from || '/workspace';
    const fetchStatus = useSelector(selectFetchStatus);
    const [passwordError, setPasswordError] = useState('');

    useEffect(() => {
        dispatch(setSignUpStep('registerEmail'));
    }, []);

    const submit = () => {
        if (!validateEmail(email) || !password) {
            !validateEmail(email) ? setEmailError('Email address is invalid.') : setEmailError('');
            !password ? setPasswordError('Enter password') : setPasswordError('');
            return;
        }

        setEmailError('');
        setPasswordError('');
        dispatch(signInThunk({
            username: email,
            password,
            from,
        }));
    };

    return (
        <Entrance>
            <MotionWrapper className={styles.wrapper}>
                <div className={styles.head}>
                    <TypographyLogo />
                    <span className={styles.head_devider} />
                    <span className={styles.head_title}>Sign in</span>
                </div>
                <span className={styles.description}>Please sign in to continue to your account.</span>
                <Input
                    focused
                    label="Email"
                    type="text"
                    value={email}
                    onChange={setEmail}
                    error={emailError}
                    wrapperClassName={styles.username}
                />
                <Input
                    label="Password"
                    value={password}
                    type="password"
                    error={passwordError}
                    onChange={setPassword}
                />
                <div className={styles.midd_row}>
                    <span />
                    <div
                        className={styles.midd_row_forgot_password}
                        onClick={() => navigate('/forgetpassword')}
                    >
                        <LockIcon />
                        <span>Forgot your password?</span>
                    </div>
                </div>
                <Button
                    text="Sign In"
                    onClick={submit}
                    className={styles.CTA}
                    loading={fetchStatus === 'Pending'}
                />
                <div className={styles.joinNow}>
                    Don’t have an account? <span onClick={() => navigate('/signup', { state: { from } })}>Sign up</span>
                </div>
            </MotionWrapper>
        </Entrance>
    );
};

export default SignIn;
